import NextImage, { ImageProps as NextImageProps } from 'next/image'
import { ReactElement } from 'react'
import NextLink from 'next/link'
import Box from '@mui/material/Box'
import { DISABLE_NEXT_IMAGE_OPTIMIZATION } from '@/config'
import { isNil } from '@/helpers/helpers'

export type ImageProps = NextImageProps & {
  href?: string
}

const ImageElement = (props: NextImageProps): ReactElement => {
  const { src, priority, fetchPriority, ...imageProps } = props
  return DISABLE_NEXT_IMAGE_OPTIMIZATION && typeof src === 'string' ? (
    <Box
      component="img"
      src={src}
      {...imageProps}
      fetchPriority={priority ? 'high' : fetchPriority}
      loading={priority ? props.loading : 'lazy'}
      decoding="async"
    />
  ) : (
    <NextImage src={src} priority={priority} {...imageProps} />
  )
}

const Image = (props: ImageProps): ReactElement => {
  const { href, ...imageProps } = props
  return isNil(href) ? (
    <ImageElement {...imageProps} />
  ) : (
    <NextLink href={href} prefetch={false} style={{ display: 'inline-flex' }}>
      <ImageElement
        {...imageProps}
        style={{
          cursor: 'pointer'
        }}
      />
    </NextLink>
  )
}

export default Image
